import { render, staticRenderFns } from "./articulos.vue?vue&type=template&id=202ce4cd&"
import script from "./articulos.vue?vue&type=script&lang=js&"
export * from "./articulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInput,QIcon,QBtn,QTooltip,QTr,QTd,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInput,QIcon,QBtn,QTooltip,QTr,QTd,QDialog})
